import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDukqu9IpFC3K5y9T7Rsc0MNMx8gtHVCNQ",
  authDomain: "listyourwishes.firebaseapp.com",
  projectId: "listyourwishes",
  storageBucket: "listyourwishes.firebasestorage.app",
  messagingSenderId: "597328233239",
  appId: "1:597328233239:web:240797bbc72d996e6c2d52",
  measurementId: "G-W57Z91FX1D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
